import React, { useState } from 'react';
import { Box, useTheme, useMediaQuery } from '@mui/material';
import Sidebar from './Sidebar';
import Header from './Header';
import MainContent from './MainContent';
import Footer from './Footer';
import CookieBanner from '../components/CookieBanner';
import CookieSettings from '../components/CookieSettings';
import { BrowserRouter as Router } from 'react-router-dom';

const LayoutV6PresetStandard = ({ children }) => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [cookieSettingsOpen, setCookieSettingsOpen] = useState(false);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('lg'));

  const toggleSidebar = () => setSidebarOpen(!sidebarOpen);
  const openCookieSettings = () => setCookieSettingsOpen(true);
  const closeCookieSettings = () => setCookieSettingsOpen(false);

  React.useEffect(() => {
    const handleOpenCookieSettings = () => {
      setCookieSettingsOpen(true);
    };

    window.addEventListener('openCookieSettings', handleOpenCookieSettings);
    
    return () => {
      window.removeEventListener('openCookieSettings', handleOpenCookieSettings);
    };
  }, []);

  return (
    <Router>
      <Box sx={{ display: 'flex', flexDirection: 'column', height: '100vh', overflow: 'hidden' }}>
        
        <Sidebar isMobile={isMobile} sidebarOpen={sidebarOpen} toggleSidebar={toggleSidebar} />
        
        <Box
          component="main"
          sx={{
            flexGrow: 1,
            bgcolor: 'background.default',
            paddingLeft: isMobile ? (sidebarOpen ? '256px' : 0) : '256px',
            transition: 'margin-left 0.3s',
            display: 'flex',
            flexDirection: 'column',
            overflowY: 'auto',
          }}
        >
          <Header isMobile={isMobile} toggleSidebar={toggleSidebar} />
          <MainContent />
          <Footer />
        </Box>

        {/* Cookie compliance components */}
        <CookieBanner onOpenSettings={openCookieSettings} />
        <CookieSettings 
          open={cookieSettingsOpen} 
          onClose={closeCookieSettings} 
        />
      </Box>
    </Router>
  );
};

export default LayoutV6PresetStandard;
